(function () {

    "use strict";

    /*
     * Most of the code in this controller is copied and modified from wacom sdk examples so it may not appear the same as the rest of Solpheo
     */

    function SignDialogController($rootScope, $translate, $mdDialog, signatureService, usersStore, $timeout) {

        var vm = this;
        var padWidth, padHeight; // size of pad screen
        var buttons; // The array of buttons that we are emulating.
        var m_clickBtn = -1;
        var intf;
        var formDiv;
        var protocol; // eslint-disable-line
        var usbDevices, idProduct;
        var tablet;
        var m_capability;
        var m_inkThreshold;
        var m_imgData;
        var m_encodingMode;
        var ctx;
        var canvas;
        var m_penData;
        var lastPoint;
        var isDown;

        vm.isSimulatedMode = false;
        vm.isLoading = false;
        vm.loadSign = true;
        vm.signature = {};
        vm.signatureImage = null;
        vm.selectedTab = 0;
        vm.startSignature = startSignature;
        vm.signatureIsValid = false;

        vm.isValidSignture = function () {

            var isNameValid = vm.signature.name ? vm.signature.name.length > 0 : false;
            var isReasonValid = vm.signature.reason ? vm.signature.reason.length > 0 : false;
            var isDistinguishedNameValid = vm.signature.distinguishedName ? vm.signature.distinguishedName.length > 0 : false;
            var isContactInfoValid = vm.signature.contactInfo ? vm.signature.contactInfo.length > 0 : false;

            vm.signatureIsValid = isNameValid && isReasonValid && isDistinguishedNameValid && isContactInfoValid;
        };

        //vm.cancel = function () {
        //    disconnect().then(function () {
        //        var data = { cancelled: true };
        //        $mdDialog.cancel(data);
        //    }).catch(function () {
        //        //toaster.error($translate.instant("SIGNATURE.CANNOT_DISCONNECT_FROM_DEVICE"));
        //        var data = { cancelled: false };
        //        $mdDialog.cancel(data);
        //    });
        //};

        vm.isSignatureInfoValid = function () {
            return vm.signature.name && vm.signature.name !== ""
                && vm.signature.distinguishedName && vm.signature.distinguishedName !== ""
                && vm.signature.reason && vm.signature.reason !== ""
                && vm.signature.location && vm.signature.location !== ""
                && vm.signature.contactInfo && vm.signature.contactInfo !== "";
        };

        vm.canSubmit = function () {
            return vm.signatureImage && !vm.isLoading;
        };

        // submit signature to backend
        vm.submitSignature = function () {
            vm.isLoading = true;

            var promise = undefined;
            if (vm.idBox && vm.idItemBox) {
                promise = signatureService.signItemBox(vm.idBox, vm.idItemBox, vm.signatureImage, vm.signature, vm.signParams);
            } else if (vm.idFileContainer && vm.idFileItem) {
                promise = signatureService.getSignFileItemContent(vm.idFileContainer, vm.idFileItem, vm.signatureImage, vm.signature, vm.signParams);
            }

            if (promise) {
                promise.then(function (result) {
                    vm.isLoading = false;
                    $mdDialog.hide(result);
                }).catch(function () {
                    var data = { cancelled: false };
                    vm.isLoading = false;
                    $mdDialog.cancel(data);
                });
            }
        };

        vm.cancel = function () {
            $mdDialog.cancel();
        };

        vm.$onInit = function () {
            setSignatureData();
            vm.isValidSignture();
            vm.startSignature();
        };

        function setSignatureData() {
            var user = $rootScope.user;
            vm.signature.pageNumber = vm.signParams.Page;
            vm.signature.name = user.userName;
            vm.signature.reason = vm.reason;
            vm.signature.distinguishedName = user.name;
            vm.signature.location = vm.reason;
            vm.signature.contactInfo = user.email;
        }

        function Rectangle(x, y, width, height) {
            this.x = x;
            this.y = y;
            this.width = width;
            this.height = height;

            this.Contains = function (pt) {
                if (((pt.x >= this.x) && (pt.x <= (this.x + this.width))) &&
                    ((pt.y >= this.y) && (pt.y <= (this.y + this.height)))) {
                    return true;
                } else {
                    return false;
                }
            };
        }

        // In order to simulate buttons, we have our own Button class that stores the bounds and event handler.
        // Using an array of these makes it easy to add or remove buttons as desired.
        //  delegate void ButtonClick();
        function Button() {
            this.Bounds; // in Screen coordinates
            this.Text;
            this.Click;
        }

        function Point(x, y) {
            this.x = x;
            this.y = y;
        }

        function createModalWindow(width, height) {

            formDiv = document.createElement('div');
            formDiv.id = "signatureWindow";
            formDiv.className = "active";
            formDiv.style.width = width + "px";
            formDiv.style.height = height + "px";
            document.getElementById("signatureCanvasModal").innerHTML = "";
            document.getElementById("signatureCanvasModal").appendChild(formDiv);

            canvas = document.createElement("canvas");
            canvas.id = "myCanvas";
            canvas.height = formDiv.offsetHeight;
            canvas.width = formDiv.offsetWidth;
            formDiv.appendChild(canvas);
            ctx = canvas.getContext("2d");

            if (canvas.addEventListener) {
                canvas.addEventListener("click", onCanvasClick, false);
            } else if (canvas.attachEvent) {
                canvas.attachEvent("onClick", onCanvasClick);
            } else {
                canvas["onClick"] = onCanvasClick;
            }
        }

        function disconnect() {
            var deferred = Q.defer(); // eslint-disable-line
            if (!(undefined === tablet || null === tablet)) {
                var protocol = new WacomGSS.STU.Protocol(); // eslint-disable-line

                tablet.setInkingMode(protocol.InkingMode.InkingMode_Off).then(function (message) {
                    console.log("received: " + JSON.stringify(message));
                    return tablet.endCapture();
                }).then(function (message) {
                    console.log("received: " + JSON.stringify(message));
                    if (m_imgData) {
                        return m_imgData.remove();
                    }
                    else {
                        return message;
                    }
                }).then(function (message) {
                    console.log("received: " + JSON.stringify(message));
                    m_imgData = null;
                    return tablet.setClearScreen();
                }).then(function (message) {
                    console.log("received: " + JSON.stringify(message));
                    return tablet.disconnect();
                }).then(function (message) {
                    console.log("received: " + JSON.stringify(message));
                    tablet = null;
                    // clear canvas
                    clearCanvas(canvas, ctx);
                }).then(function () {
                    deferred.resolve();
                }).fail(function (message) {
                    console.log("disconnect error: " + message);
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }


        /*
         * Main function from wacom sdk example
         * Connects to the signature pad (if not accessible start manual mode), and draws the canvas that will be displayed on it
         */
        function startSignature() {

            //WacomGSS.STU = new WacomGSS.STUConstructor(initSignatureInUsbDevices);

            //$timeout(function () {
            //    console.log("Start simulated mode manual");
            startSimulatedMode();
            //}, 50);

        }

        function initSignatureInUsbDevices() {
            //var p = new WacomGSS.STU.Protocol(); // eslint-disable-line
            //m_encodingMode;
            //var m_usingEncryption = false;
            //var m_encH;
            //var m_encH2;
            //var m_encH2Impl;

            //disconnect().then(function () {
            //    console.log('Init usb devices');
            //    return WacomGSS.STU.getUsbDevices(); // eslint-disable-line
            //}).then(function (message) {
            //    usbDevices = message;
            //    console.log("received: " + JSON.stringify(message));

            //    idProduct = usbDevices[0].idProduct;
            //    return WacomGSS.STU.isSupportedUsbDevice(usbDevices[0].idVendor, idProduct); // eslint-disable-line
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message)); // eslint-disable-line
            //    intf = new WacomGSS.STU.UsbInterface(); // eslint-disable-line
            //    return intf.Constructor();
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    return intf.connect(usbDevices[0], true);
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    console.log(0 === message.value ? "connected!" : "not connected");
            //    if (0 === message.value) {
            //        m_encH = new WacomGSS.STU.EncryptionHandler(new encryptionHandler()); // eslint-disable-line
            //        return m_encH.Constructor();
            //    }
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    m_encH2Impl = new encryptionHandler2(); // eslint-disable-line
            //    m_encH2 = new WacomGSS.STU.EncryptionHandler2(m_encH2Impl); // eslint-disable-line
            //    return m_encH2.Constructor();
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    tablet = new WacomGSS.STU.Tablet(); // eslint-disable-line
            //    return tablet.Constructor(intf, m_encH, m_encH2);
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    intf = null;
            //    return tablet.getInkThreshold();
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    m_inkThreshold = message;
            //    return tablet.getCapability();
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    m_capability = message;
            //    padWidth = m_capability.screenWidth;
            //    padHeight = m_capability.screenHeight;
            //    createModalWindow(padWidth, padHeight);
            //    return tablet.getInformation();
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    return tablet.getInkThreshold();
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    return tablet.getProductId();
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    return WacomGSS.STU.ProtocolHelper.simulateEncodingFlag(message, m_capability.encodingFlag); // eslint-disable-line
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    var encodingFlag = message;
            //    if ((encodingFlag & p.EncodingFlag.EncodingFlag_24bit) !== 0) {
            //        return tablet.supportsWrite().then(function (message) {
            //            m_encodingMode = message ? p.EncodingMode.EncodingMode_24bit_Bulk : p.EncodingMode.EncodingMode_24bit;
            //        });
            //    } else if ((encodingFlag & p.EncodingFlag.EncodingFlag_16bit) !== 0) {
            //        return tablet.supportsWrite().then(function (message) {
            //            m_encodingMode = message ? p.EncodingMode.EncodingMode_16bit_Bulk : p.EncodingMode.EncodingMode_16bit;
            //        });
            //    } else { // assumes 1bit is available
            //        m_encodingMode = p.EncodingMode.EncodingMode_1bit;
            //    }
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    return tablet.isSupported(p.ReportId.ReportId_EncryptionStatus); // v2 encryption
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    m_usingEncryption = false; //message return if device support encryption;
            //    // if the encryption script is missing turn off encryption regardless
            //    if (typeof window.sjcl === 'undefined') {
            //        console.log("sjcl not found - encryption disabled");
            //        m_usingEncryption = false;
            //    }
            //    return tablet.getDHprime();
            //}).then(function (dhPrime) {
            //    console.log("received: " + JSON.stringify(dhPrime));
            //    return WacomGSS.STU.ProtocolHelper.supportsEncryption_DHprime(dhPrime); // eslint-disable-line
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    m_usingEncryption = (message ? true : m_usingEncryption);
            //    return tablet.setClearScreen();
            //}).then(function (message) {
            //    if (m_usingEncryption) {
            //        return tablet.startCapture(0xc0ffee);
            //    }
            //    return message;
            //}).then(function (message) {
            //    if (typeof m_encH2Impl.error !== 'undefined') {
            //        throw new Error("Encryption failed, restarting demo");
            //    }
            //    return message;
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    return tablet.isSupported(p.ReportId.ReportId_PenDataOptionMode);
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    if (message) {
            //        return tablet.getProductId().then(function (message) {
            //            var penDataOptionMode = p.PenDataOptionMode.PenDataOptionMode_None;
            //            switch (message) {
            //                case WacomGSS.STU.ProductId.ProductId_520A: // eslint-disable-line
            //                    penDataOptionMode = p.PenDataOptionMode.PenDataOptionMode_TimeCount;
            //                    break;
            //                case WacomGSS.STU.ProductId.ProductId_430: // eslint-disable-line
            //                case WacomGSS.STU.ProductId.ProductId_530: // eslint-disable-line
            //                    penDataOptionMode = p.PenDataOptionMode.PenDataOptionMode_TimeCountSequence;
            //                    break;
            //                default:
            //                    console.log("Unknown tablet supporting PenDataOptionMode, setting to None.");
            //            }
            //            return tablet.setPenDataOptionMode(penDataOptionMode);
            //        });
            //    }
            //    else {
            //        m_encodingMode = p.EncodingMode.EncodingMode_1bit;
            //        return m_encodingMode;
            //    }
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    drawCanvas();
            //    var canvasImage = canvas.toDataURL("image/jpeg");
            //    return WacomGSS.STU.ProtocolHelper.resizeAndFlatten(canvasImage, 0, 0, 0, 0, padWidth, padHeight, m_encodingMode, 1, false, 0, true); // eslint-disable-line
            //}).then(function (message) {
            //    m_imgData = message;
            //    console.log("received: " + JSON.stringify(message));
            //    return tablet.writeImage(m_encodingMode, message);
            //}).then(function (message) {
            //    if (m_encH2Impl.error) {
            //        throw new Error("Encryption failed, restarting demo");
            //    }
            //    return message;
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    return tablet.setInkingMode(p.InkingMode.InkingMode_On);
            //}).then(function (message) {
            //    console.log("received: " + JSON.stringify(message));
            //    var reportHandler = new WacomGSS.STU.ProtocolHelper.ReportHandler(); // eslint-disable-line
            //    lastPoint = { "x": 0, "y": 0 };
            //    isDown = false;
            //    ctx.lineWidth = 2;

            //    var penData = function (report) {
            //        //console.log("report: " + JSON.stringify(report));
            //        m_penData.push(report);
            //        processButtons(report, canvas);
            //        processPoint(report, canvas, ctx);
            //    };
            //    var penDataEncryptedOption = function (report) {
            //        //console.log("reportOp: " + JSON.stringify(report));
            //        m_penData.push(report.penData[0], report.penData[1]);
            //        processButtons(report.penData[0], canvas);
            //        processPoint(report.penData[0], canvas, ctx);
            //        processButtons(report.penData[1], canvas);
            //        processPoint(report.penData[1], canvas, ctx);
            //    };

            //    var log = function (report) {
            //        console.log("report: " + JSON.stringify(report));
            //    };

            //    var decrypted = function (report) {
            //        console.log("decrypted: " + JSON.stringify(report));
            //    };

            //    m_penData = new Array();
            //    reportHandler.onReportPenData = penData;
            //    reportHandler.onReportPenDataOption = penData;
            //    reportHandler.onReportPenDataTimeCountSequence = penData;
            //    reportHandler.onReportPenDataEncrypted = penDataEncryptedOption;
            //    reportHandler.onReportPenDataEncryptedOption = penDataEncryptedOption;
            //    reportHandler.onReportPenDataTimeCountSequenceEncrypted = penData;
            //    reportHandler.onReportDevicePublicKey = log;
            //    reportHandler.onReportEncryptionStatus = log;
            //    reportHandler.decrypt = decrypted;
            //    return reportHandler.startReporting(tablet, true);
            //})
            //.fail(function (message) {
            //    console.log(message);
            //    function restartIt() {
            //        $timeout(tablet, 250);
            //    }
            //    disconnect()
            //    .then(restartIt)
            //    .fail(restartIt);
            //});
        }

        /*
         * Simulated mode if no pad is accessible
         * To keep things simple and have a better integration with the original code from wacom sdk, this function just simulates a 520A pad
         */
        function startSimulatedMode() {
            vm.startSimulatedMode = true;

            // size of simulated area
            m_capability = {
                encodingFlag: 0,
                maxReportRate: 200,
                resolution: 2540,
                screenHeight: 480,
                screenWidth: 800,
                tabletMaxPressure: 511,
                tabletMaxX: 10400,
                tabletMaxY: 6048
            };
            m_inkThreshold = {
                offPressureMark: 16,
                onPressureMark: 21
            };
            padWidth = m_capability.screenWidth;
            padHeight = m_capability.screenHeight;
            idProduct = "what?";// WacomGSS.STU.ProductId.ProductId_520A; // eslint-disable-line

            m_penData = [];

            createModalWindow(padWidth, padHeight);
            drawCanvas();
            setupSimulationListener();
        }

        /*
         * Draws the canvas on the inside the modal
         */
        function drawCanvas() {
            buttons = new Array(3);
            buttons[0] = new Button();
            buttons[1] = new Button();
            buttons[2] = new Button();

            if (idProduct !== WacomGSS.STU.ProductId.ProductId_300) { // eslint-disable-line
                // Place the buttons across the bottom of the screen.
                var w2 = padWidth / 3;
                var w3 = padWidth / 3;
                var w1 = padWidth - w2 - w3;
                var y = padHeight * 6 / 7;
                var h = padHeight - y;

                buttons[0].Bounds = new Rectangle(0, y, w1, h);
                buttons[1].Bounds = new Rectangle(w1, y, w2, h);
                buttons[2].Bounds = new Rectangle(w1 + w2, y, w3, h);
            } else {
                // The STU-300 is very shallow, so it is better to utilise
                // the buttons to the side of the display instead.

                var x = padWidth * 3 / 4;
                var w = padWidth - x;

                var h2 = padHeight / 3;
                var h3 = padHeight / 3;
                var h1 = padHeight - h2 - h3;

                buttons[0].Bounds = new Rectangle(x, 0, w, h1);
                buttons[1].Bounds = new Rectangle(x, h1, w, h2);
                buttons[2].Bounds = new Rectangle(x, h1 + h2, w, h3);
            }

            buttons[0].Text = $translate.instant("SIGNATURE.OK");
            buttons[1].Text = $translate.instant("SIGNATURE.CLEAR");
            buttons[2].Text = $translate.instant("SIGNATURE.CANCEL");
            buttons[0].Click = btnOk_Click;
            buttons[1].Click = btnClear_Click;
            buttons[2].Click = btnCancel_Click;

            clearCanvas(canvas, ctx);
            ctx.save();
            ctx.setTransform(1, 0, 0, 1, 0, 0);

            ctx.beginPath();
            ctx.lineWidth = 2;
            ctx.strokeStyle = 'black';
            ctx.font = "30px Arial";

            // Draw the buttons
            for (var i = 0; i < buttons.length; ++i) {

                ctx.fillStyle = "black";
                ctx.rect(buttons[i].Bounds.x, buttons[i].Bounds.y, buttons[i].Bounds.width, buttons[i].Bounds.height);
                var xPos = buttons[i].Bounds.x + ((buttons[i].Bounds.width / 2) - (ctx.measureText(buttons[i].Text).width / 2));
                var yOffset;
                if (idProduct === WacomGSS.STU.ProductId.ProductId_300) // eslint-disable-line
                    yOffset = 28;
                else if (idProduct === WacomGSS.STU.ProductId.ProductId_430) // eslint-disable-line
                    yOffset = 26;
                else
                    yOffset = 40;
                ctx.fillText(buttons[i].Text, xPos, buttons[i].Bounds.y + yOffset);
            }

            /* signature line */
            ctx.font = "30px Verdana";
            ctx.textAlign = "center";
            ctx.fillText("X........................................", padWidth / 2, padHeight / 2);

            /* signer and reason information */
            y = padHeight / 7;
            var fontSize = 24;

            ctx.font = fontSize + "px Verdana";
            ctx.textAlign = "left";
            ctx.fillStyle = "black";

            ctx.fillText(vm.signature.name, 10, padHeight - y - 3 * fontSize);
            ctx.fillText(vm.signature.reason, 10, padHeight - y - 1.5 * fontSize);

            ctx.stroke();
            ctx.closePath();

            ctx.restore();
        }

        /*
         * Clears the screen
         */
        function clearScreen() {
            clearCanvas(canvas, ctx);
            drawCanvas();
            m_penData = new Array();
            tablet.writeImage(m_encodingMode, m_imgData);
        }

        function btnOk_Click() {
            // You probably want to add additional processing here.
            generateImage();
            setTimeout(close, 0);
        }

        function btnCancel_Click() {
            // You probably want to add additional processing here.
            vm.cancel();
        }

        function btnClear_Click() {
            // You probably want to add additional processing here.
            console.log("clear!");
            clearScreen();
        }

        function distance(a, b) {
            return Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2);
        }

        function clearCanvas(in_canvas, in_ctx) {
            in_ctx.save();
            in_ctx.setTransform(1, 0, 0, 1, 0, 0);
            in_ctx.fillStyle = "white";
            in_ctx.fillRect(0, 0, in_canvas.width, in_canvas.height);
            in_ctx.restore();
        }

        function processButtons(point, in_canvas) {
            var nextPoint = {};
            nextPoint.x = Math.round(in_canvas.width * point.x / m_capability.tabletMaxX);
            nextPoint.y = Math.round(in_canvas.height * point.y / m_capability.tabletMaxY);
            var isDown2 = (isDown ? !(point.pressure <= m_inkThreshold.offPressureMark) : (point.pressure > m_inkThreshold.onPressureMark));

            var btn = -1;
            for (var i = 0; i < buttons.length; ++i) {
                if (buttons[i].Bounds.Contains(nextPoint)) {
                    btn = i;
                    break;
                }
            }

            if (isDown && !isDown2) {
                if (btn !== -1 && m_clickBtn === btn) {
                    buttons[btn].Click();
                }
                m_clickBtn = -1;
            }
            else if (btn !== -1 && !isDown && isDown2) {
                m_clickBtn = btn;
            }
            return (btn === -1);
        }

        function processPoint(point, in_canvas, in_ctx) {
            var nextPoint = {};
            nextPoint.x = Math.round(in_canvas.width * point.x / m_capability.tabletMaxX);
            nextPoint.y = Math.round(in_canvas.height * point.y / m_capability.tabletMaxY);
            var isDown2 = (isDown ? !(point.pressure <= m_inkThreshold.offPressureMark) : (point.pressure > m_inkThreshold.onPressureMark));

            if (!isDown && isDown2) {
                lastPoint = nextPoint;
            }

            if ((isDown2 && 10 < distance(lastPoint, nextPoint)) || (isDown && !isDown2)) {
                in_ctx.beginPath();
                in_ctx.moveTo(lastPoint.x, lastPoint.y);
                in_ctx.lineTo(nextPoint.x, nextPoint.y);
                in_ctx.stroke();
                in_ctx.closePath();
                lastPoint = nextPoint;
            }

            isDown = isDown2;
        }

        /*
         * Generates an image from user's signature
         */
        function generateImage() {
            var signatureCanvas = document.createElement("canvas");
            signatureCanvas.height = formDiv.offsetHeight;
            signatureCanvas.width = formDiv.offsetWidth;
            signatureCanvas.id = "signatureCanvas";
            var signatureCtx = signatureCanvas.getContext("2d");

            clearCanvas(signatureCanvas, signatureCtx);
            signatureCtx.lineWidth = 2;
            signatureCtx.strokeStyle = 'black';
            lastPoint = { "x": 0, "y": 0 };
            isDown = false;
            for (var i = 0; i < m_penData.length; i++) {
                processPoint(m_penData[i], signatureCanvas, signatureCtx);
            }

            var el = document.getElementById('myCanvas');
            el.parentNode.removeChild(el);
            formDiv.appendChild(signatureCanvas);
            vm.signatureImage = signatureCanvas.toDataURL("image/jpeg");
        }

        function close() {
            disconnect();
        }

        function onCanvasClick(e) {
            // Enable the mouse to click on the simulated buttons that we have displayed.

            // Note that this can add some tricky logic into processing pen data
            // if the pen was down at the time of this click, especially if the pen was logically
            // also 'pressing' a button! This demo however ignores any that.

            for (var i = 0; i < buttons.length; i++) {
                if (buttons[i].Bounds.Contains(new Point(e.offsetX, e.offsetY))) {
                    buttons[i].Click();
                    break;
                }
            }
        }

        /*
         * Setup event listeners that simulates the pad on the canvas displayed in the modal
         */
        function setupSimulationListener() {
            canvas.addEventListener("mousedown", onMouseDown);


            function onMouseDown(e) {
                canvas.addEventListener("mouseup", onMouseUp);
                canvas.addEventListener("mouseleave", onMouseUp);
                canvas.addEventListener("mouseout", onMouseUp);
                canvas.addEventListener("mousemove", onMouseMove);

                ctx.lineWidth = 2;

                newPenData(e, m_inkThreshold.onPressureMark + 1);
            }

            function onMouseUp(e) {
                canvas.removeEventListener("mousemove", onMouseMove);

                newPenData(e, m_inkThreshold.offPressureMark - 1);
            }

            function onMouseMove(e) {
                newPenData(e, m_inkThreshold.onPressureMark + 1);
            }

            function newPenData(event, pressure) {
                var currX = event.offsetX;
                var currY = event.offsetY;

                currX = Math.round((currX / canvas.width) * m_capability.tabletMaxX);
                currY = Math.round((currY / canvas.height) * m_capability.tabletMaxY);
                var report = {
                    x: currX,
                    y: currY,
                    pressure: pressure
                };
                m_penData.push(report);
                processPoint(report, canvas, ctx);
            }

        }
        // KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK

        var canvas = null;
        var ctx = null;

        function timedDetect() {
            if (wgssSignatureSDK.running) {
                document.getElementById("statusText").innerHTML = "Signature SDK Service detected";
            }
            else {
                document.getElementById("statusText").innerHTML = "Signature SDK Service not detected";
            }
        }
        var timeout = setTimeout(timedDetect, 1500);

        function onDetectRunning() {
            document.getElementById("statusText").innerHTML = "Signature SDK Service detected";
            clearTimeout(timeout);
        }
        // pass the starting service port  number as configured in the registry
        var wgssSignatureSDK = new WacomGSS_SignatureSDK(onDetectRunning, 8000);

        function restartSession(onRestartSession) {
            document.getElementById("statusText").innerHTML += "<br>Restarting the session";
            wgssSignatureSDK = new WacomGSS_SignatureSDK(onRestartSession, 8000);
        }

        vm.captureSignature = function () {
            var sigObj;
            var sigCtl;
            var dynCapt;

            function onPutSigData(sigObjV, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    document.getElementById("statusText").innerHTML += "<br>PutSigData called";
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>error on PutSigData: " + status;
                }
            }

            function onGetSigText(sigObjV, data, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    document.getElementById("statusText").innerHTML += "<br>SigText: " + data;
                    var vData = new wgssSignatureSDK.Variant();
                    vData.type = wgssSignatureSDK.VariantType.VARIANT_BASE64;
                    vData.base64 = data;
                    sigObjV.PutSigData(vData, onPutSigData);
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>error on GetSigData: " + status;
                }
            }

            function onGetAdditionalData(sigObjV, additionalData, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    document.getElementById("statusText").innerHTML += "<br>Additional Data/MachineOS: " + additionalData;
                    sigObjV.GetSigText(onGetSigText);
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>error on GetAdditionalData: " + status;
                }
            }

            function onRenderBitmap(sigObjV, bmpObj, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    if (bmpObj.isBase64) {
                        document.getElementById("statusText").innerHTML += "<br>Base64 bitmap retrieved:<br>";
                        document.getElementById("statusText").innerHTML += "<br>" + bmpObj.image.src;
                        vm.signatureImage = bmpObj.image.src;
                    }
                    else {
                        document.getElementById("statusText").innerHTML += "<br>Bitmap retrieved, rendering image...";
                    }
                    ctx.drawImage(bmpObj.image, 0, 0);
                    sigObjV.GetAdditionalData(wgssSignatureSDK.CaptData.CaptMachineOS, onGetAdditionalData);
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>Signature Render Bitmap error: " + status;
                }
            }

            function onPutExtraData(sigObjV, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    document.getElementById("statusText").innerHTML += "<br>Rendering bitmap";
                    var flags = wgssSignatureSDK.RBFlags.RenderOutputPicture |
                        wgssSignatureSDK.RBFlags.RenderColor24BPP;
                    sigObjV.RenderBitmap("jpeg", canvas.width, canvas.height, 0.7, 0x00000000, 0x00FFFFFF, flags, 0, 0, onRenderBitmap);
                    this.sigObj = sigObjV;
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>Signature PutExtraData error: " + status;
                }
            }

            function onDynCaptCapture(dynCaptV, sigObjV, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    document.getElementById("statusText").innerHTML += "<br>Adding extra data";
                    sigObjV.PutExtraData("extra key", "extra value", onPutExtraData);
                }
                else if (1 == status) {
                    document.getElementById("statusText").innerHTML += "<br>Signature capture cancelled by the user";
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>Signature capture error: " + status;
                }
            }

            function onSigCtlPutLicence(sigCtlV, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    dynCapt.Capture(sigCtlV, vm.signature.distinguishedName, vm.signature.reason, vm.signature.name, vm.signature.location, onDynCaptCapture);
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>SigCtl constructor error: " + status;
                }
            }

            function onSigCtlConstructor(sigCtlV, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    sigCtlV.PutLicence(LICENCEKEY, onSigCtlPutLicence);
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>SigCtl constructor error: " + status;
                }
            }

            function onDynCaptConstructor(dynCaptV, status) {
                if (wgssSignatureSDK.ResponseStatus.OK == status) {
                    this.sigCtl = new wgssSignatureSDK.SigCtl(onSigCtlConstructor);
                }
                else {
                    document.getElementById("statusText").innerHTML += "<br>Dynamic Capture constructor error: " + status;
                    if (wgssSignatureSDK.ResponseStatus.INVALID_SESSION == status) {
                        restartSession(captureSignature);
                    }
                }
            }

            if (wgssSignatureSDK.running) {
                if (null == canvas) {
                    canvas = document.getElementById("myCanvas");
                    ctx = canvas.getContext("2d");
                }
                dynCapt = new wgssSignatureSDK.DynamicCapture(onDynCaptConstructor);
            }
        };


    }

    SignDialogController.$inject = ["$rootScope", "$translate", "$mdDialog", "solpheo.signatureService", "sphForms.usersStore", "$timeout"];

    angular.module("sphforms.main")
        .component("solpheoSignDialog", {
            controller: SignDialogController,
            bindings: {
                idBox: "<",
                idItemBox: "<",
                idFileContainer: "<",
                idFileItem: "<",
                signParams: "<",
                reason: "<"
            },
            templateUrl: "modules/main/components/basicTask/sign.dialog.template.html"
        });

}());